"use client";

import { useEffect } from "react";
import { successToast,errorToast } from '../../utils/toasters'
import { isAuthenticated } from "../../utils/helpers";

// This component handles automatic event submission after login
export default function EventHandler() {
  useEffect(() => {
    // Check if there's pending event data and user is authenticated
    const pendingData = localStorage.getItem("pendingEventData");
    if (pendingData && isAuthenticated()) {
      try {
        // Parse the stored event data
        const parsedData = JSON.parse(pendingData);

        // Show notification
        successToast("Completing your saved event posting...", {
          position: "top-right",
          autoClose: 3000,
        });

        // Submit the event based on its type
        submitPendingEvent(parsedData);

        // Clear the stored data
        localStorage.removeItem("pendingEventData");
      } catch (error) {
        console.error("Error processing pending event data:", error);
        localStorage.removeItem("pendingEventData");
        errorToast("Failed to restore your saved event. Please try again.");
      }
    }
  }, []);

  // Function to submit the pending event
  const submitPendingEvent = async (eventData) => {
    try {
      if (eventData.eventType === "Personal Events") {
        await submitPersonalEvent(eventData);
      } else if (eventData.eventType === "Community Events") {
        await submitCommunityEvent(eventData);
      } else if (eventData.eventType === "Commercial Event") {
        await submitCommercialEvent(eventData);
      }

      successToast("Your event has been successfully posted!");
    } catch (error) {
      console.error("Error submitting event:", error);
      errorToast("Failed to post your event. Please try again.");
    }
  };

  // Submit personal event
  const submitPersonalEvent = async (eventData) => {
    const payload = new FormData();
    payload.append("eventName", eventData.eventName);
    payload.append("eventType", eventData.eventTypeDetail);
    payload.append("date", eventData.date + " 00:00:00.000");
    payload.append("venue", eventData.venue);
    payload.append("guestCount", eventData.guests.toString());
    payload.append("budget", eventData.budget.toString());
    payload.append("description", eventData.description);
    payload.append("selectedEventNeeds", eventData.needs);
    payload.append("selectedEventIds", JSON.stringify(eventData.vendors));
    payload.append("businessid", eventData.vendors);

    const { addPersonalEvents } = await import("../../services/events");
    await addPersonalEvents(payload);
  };

  // Submit community event
  const submitCommunityEvent = async (eventData) => {
    const { handlePostRequest, addCommunityEvents } = await Promise.all([
      import("../../hooks/api").then((module) => module.handlePostRequest),
      import("../../services/events").then(
        (module) => module.addCommunityEvents
      ),
    ]);

    const imageData = new FormData();
    imageData.append("image", eventData.tempCommunityImage);
    const imageUrl = await handlePostRequest(
      "/auth/upload-image-to-s3",
      imageData,
      {},
      true
    );

    const payload = {
      name: eventData.eventName,
      date: eventData.date,
      time: `${eventData.startTime} - ${eventData.endTime}`,
      location: eventData.venue,
      description: eventData.description,
      cover_image: imageUrl.data[0],
      city: eventData.city,
      state: eventData.state,
    };

    await addCommunityEvents(payload);
  };

  // Submit commercial event
  const submitCommercialEvent = async (eventData) => {
    const { handlePostRequest, addCommercialEvents } = await Promise.all([
      import("../../hooks/api").then((module) => module.handlePostRequest),
      import("../../services/events").then(
        (module) => module.addCommercialEvents
      ),
    ]);

    const imageData = new FormData();
    imageData.append("image", eventData.tempCommunityImage);
    const imageUrl = await handlePostRequest(
      "/auth/upload-image-to-s3",
      imageData,
      {},
      true
    );

    const payload = {
      name: eventData.eventName,
      date: eventData.date,
      time: `${eventData.startTime} - ${eventData.endTime}`,
      location: eventData.venue,
      description: eventData.description,
      cover_image: imageUrl.data[0],
      city: eventData.city,
      state: eventData.state,
    };

    await addCommercialEvents(payload);
  };

  // This component doesn't render anything visible
  return null;
}
